// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__kFVL_","spin":"style_spin__r_DKh"};